import type { EagerJobsTbdSdk } from '@fiverr-private/jtbd_sdk';
import { openSourcingDrawerInternal } from '@fiverr-private/expert_sourcing_domain_selection_drawer_trigger';
import { getJobInfo } from './utils/getJobInfo';

export const SourcingCard = {
    getJobInfo,
    cardCallbacks: {
        customActionCallback: () => {
            openSourcingDrawerInternal({
                source: 'jtbd_card_sourcing',
            });
        },
    },
} satisfies EagerJobsTbdSdk;
